import {
  createActions, asyncInitialState, asyncOnRequest,
  asyncOnSuccess, asyncOnError, asyncSelectors
} from '../utils'

export const { types, actions } = createActions({
  setSelected: (row) => ({ row }),
  clear: () => null,
  asyncs: {
  }
}, 'cdReservationLots');

const initialState = asyncInitialState({
  selected: null,
  gridOptions: {
    doubleClickActionTab: '',
    suppressEditDeleteInContextMenu: true,
  },
  deleteObj: null,
  Actions: {
  },
  Columns: [
    { headerName: 'Lot', field: 'Lot', minWidth: 150 },
    { headerName: 'Reserved', field: 'ReservedQuantityDisplay', type: 'numericColumn' },
    { headerName: 'Description', field: 'LotDescription' }
  ],
  Data: []
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.clear:
      return {
        ...state,
        data: {
          ...state.data,
          Data: []
        }
      }

    case types.setSelected:
      const selected = action.data.row;
      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      }

    default:
      return state;
  }
};

const asyncSelector = asyncSelectors(
  (state) => state.salesOrderEnquiry.cdReservationLots,
  {
    Data: data => data.Data,
    selected: data => data.selected,
    Actions: data => data.Actions,
  }
)

const syncSelector = {
  isLoading: state => state.salesOrderEnquiry.cdReservationLots.loading,
  gridOptions: state => state.salesOrderEnquiry.cdReservationLots.data.gridOptions,
  Columns: state => state.salesOrderEnquiry.cdReservationLots.data.Columns,
  Actions: state => state.salesOrderEnquiry.cdReservationLots.data.Actions,
}

export const selectors = Object.assign({}, asyncSelector, syncSelector)